import styled from "styled-components";

export const StyledModalCicloAdd = styled.div`
@media only screen and (max-width: 768px) {
    .escalonado {
        .escalonado-responsivo {
            flex-direction: column;
        }

        .full-responsivo {
            width: 100% !important;
        }
    }
}

.atividades {
    // border: 1px solid #ccc;
    // margin: 20px 0;
    // padding: 14px 0;
}

.add-escalonamento {
    font-size: 12px;
    color: #000;
    text-decoration: none;
}

.escalonamento-atividade {
    margin: 10px
}

 .default-button-red-small {
    max-width: 280px;
    min-width: 100px;
    padding: 0.20rem .25rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #EE4B21;
    border-radius: 0.25rem;
    background-color: #EE4B21;
    color: #FFF;
    font-size: 0.77rem;
     &:hover {
        background-color: #c83e1b;
        border: solid 1px #c83e1b;
    }
    &:disabled {
        cursor: not-allowed;
    }
}


.default-button-red-invert-small {
    max-width: 280px;
    min-width: 100px;
    padding: 0.20rem .25rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #EE4B21;
    border-radius: 0.25rem;
    background-color: #FFF;
    color: #EE4B21;
    font-size: 0.77rem;
     &:hover {
        background-color: #fff0f09e;
        border: solid 1px #c83e1b99;
    }
    &:disabled {
        cursor: not-allowed;
    }
}


.default-button-red-invert-small-icon {
    min-width: 3ch;
    padding: 0.20rem .25rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #EE4B21;
    border-radius: 0.25rem;
    background-color: #FFF;
    color: #EE4B21;
    font-size: 1rem;
    &:hover {
        background-color: #fff0f09e;
        border: solid 1px #c83e1b99;
    }
    &:disabled {
        cursor: not-allowed;
    }
}

.default-button-red-invert-small-icon-block {
    width: 80%;
    height: 90%;
    padding: 0.20rem .25rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #EE4B21;
    border-radius: 0.25rem;
    background-color: #FFF;
    color: #EE4B21;
    font-size: 1.3rem;
    &:hover {
        background-color: #fff0f09e;
        border: solid 1px #c83e1b99;
    }
    &:disabled {
        cursor: not-allowed;
    }
}
`;
